import {createAction} from 'redux-act'

export interface AuthFormActionPayload<F = any> {
  form: F;
  success: (...args: any[]) => void;
  error: (...args: any[]) => void;
  obj?: any;
  callback?: () => void;
}

export interface LogoutActionPayload {
  success: (...args: any[]) => void;
  error: (...args: any[]) => void;
  obj?: any;
}

export interface GetUserActionPayload {
  force?: boolean;
  load?: boolean;
  callback?: () => void;
  fallback?: () => void;
}

export interface AuthApiResponse {
  result?: string;
  data?: Record<string, any>;
  [key: string]: any;
}

export interface SocketsConnectingPayload {
  userId: number | string;
  role: string;
}

export const login = createAction<AuthFormActionPayload>('LOGIN')
export const handleLoginModal = createAction('HANDLE_LOGIN_MODAL')
export const handleForgotModal = createAction('HANDLE_FORGOT_MODAL')
export const handleRegisterModal = createAction('HANDLE_REGISTER_MODAL')
export const handleCloseModal = createAction('HANDLE_CLOSE_MODAL')

export const register = createAction<AuthFormActionPayload>('REGISTER')
export const requestRegister = createAction<AuthFormActionPayload>('REQUEST_REGISTER')

export const forgot = createAction<AuthFormActionPayload>('FORGOT')
export const requestForgot = createAction<AuthFormActionPayload>('REQUEST_FORGOT')

export const logout = createAction<LogoutActionPayload>('LOGOUT')
export const handleLogout = createAction('HANDLE_LOGOUT')

export const getUser = createAction<GetUserActionPayload | undefined>('GET_USER')
export const getServer = createAction('GET_SERVER')

export const postUser = createAction<AuthFormActionPayload>('POST_USER')
export const handleGetUser = createAction<AuthApiResponse>('HANDLE_GET_USER')
export const handleAuth = createAction('HANDLE_AUTH')

export const socketsConnecting = createAction<SocketsConnectingPayload>('SOCKETS_CONNECTING');
